import ScheduleType from "../pages/Schedules/ScheduleType";

export type ScheduleBaseSlot = {
  exists: boolean;
  id?: number;
  date?: string;
  status?: number;
  consultant_id?: number;
  video_call?: boolean;
  note?: string | null;
};

export type ScheduleBaseSlotResult =
  | { ok: true; slot: ScheduleBaseSlot }
  | { ok: false; error: string };

export function parseScheduleBaseSlotPayload(payload: unknown): ScheduleBaseSlot {
  if (!payload || typeof payload !== "object") {
    return { exists: false };
  }

  const data = payload as Record<string, unknown>;

  if (data.exists === false) {
    return { exists: false };
  }

  if (data.exists !== true) {
    return { exists: false };
  }

  return {
    exists: true,
    id: typeof data.id === "number" ? data.id : undefined,
    date: typeof data.date === "string" ? data.date : undefined,
    status: typeof data.status === "number" ? data.status : undefined,
    consultant_id:
      typeof data.consultant_id === "number" ? data.consultant_id : undefined,
    video_call:
      typeof data.video_call === "boolean"
        ? data.video_call
        : data.video_call === 1,
    note: typeof data.note === "string" ? data.note : data.note ?? null,
  };
}

export function isBlockedScheduleSlot(slot: ScheduleBaseSlot): boolean {
  return slot.exists === true && slot.status === ScheduleType.LOCKED;
}

export function resolveScheduleSlotNote(slot: ScheduleBaseSlot): string | null {
  const note = slot.note?.trim();
  return note ? note : null;
}
